module.exports = __webpack_public_path__ + "static/media/icon.b76ecdbb.png";